import React from 'react'
import FreePerksEditComponent from '../../Components/Perks/FreePerksEdit'

const FreePerksEdit = ({ match, location }) => {
  return (
    <React.Fragment>
      <FreePerksEditComponent />
    </React.Fragment>
  )
}

export default FreePerksEdit
